import { ReactNode } from "react"
import { Button } from "react-bootstrap";

export function AppSectionHeaderFilterBox({ children, onReset, isDisabled }: {
  children?: ReactNode;
  onReset: () => void;
  isDisabled: boolean;
})
{
  return (
<div className="d-flex column-gap-3">
  { children }
  <Button
    size="sm"
    variant="secondary"
    className="clear-filters-button"
    onClick={() => onReset()}
    disabled={isDisabled}
  >
    Limpiar filtros
  </Button>
</div>
  )
}
